import { render } from "./edit_waiter_component.vue?vue&type=template&id=458c6f7a&scoped=true"
import script from "./edit_waiter_component.vue?vue&type=script&lang=js"
export * from "./edit_waiter_component.vue?vue&type=script&lang=js"

import "./edit_waiter_component.vue?vue&type=style&index=0&id=458c6f7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458c6f7a"]])

export default __exports__